import React from 'react';
import * as PropTypes from 'prop-types';
import get from 'lodash/get';

import TextInput from '../../../TextInput';
import SelectCustom from '../../../SelectCustom';
import ErrorBlock from '../../../common/ErrorBlock';
import { FormErrorBlock } from '../../../common/FormErrorBlock';

import { PROFILE_FIELDS_TYPES } from '../../../../constants/formFields';
import { FIELD_FILLING_TYPES } from '../../../../utils/fields/getFieldProps';

import useGetIsFieldDisabled from '../../../../hooks/patient-form/useGetIsFieldDisabled';

import styles from './index.styl';

const {
  POSTAL_CODE,
  ADDRESS_1,
  STATE,
  CITY,
  COUNTRY,
  ADDRESS_2,
  HOME_PHONE,
} = PROFILE_FIELDS_TYPES;

export function HomeAddressRowModeView({
  targetCountryEntity,
  postalCode,
  address1,
  address2,
  city,
  state,
  country,
  homePhone,
  onChange,
  countryList,
  validateErrors,
  isZipApplicable,
  statesList,
  zipLimit,
  makeProfileField,
  handleCountryChange,
  isDisabled,
  formatMessage,
  zipExamples,
  homePhoneRequired,
  cityRequired,
  address1Required,
  isAppointmentPatientForm,
  isFormSubmitted,
}) {
  const { checkIsFieldDisabled } = useGetIsFieldDisabled();

  const isPostalCodeFieldErrorExists = get(validateErrors, POSTAL_CODE);

  const isPostalCodeFieldDisabled =
    (isDisabled(POSTAL_CODE) &&
      checkIsFieldDisabled(POSTAL_CODE, validateErrors)) ||
    !isZipApplicable;

  const isPhoneNumberFieldDisabled =
    isDisabled(HOME_PHONE) && checkIsFieldDisabled(HOME_PHONE, validateErrors);

  // immediately show errors for postal code field, but for other fields
  // show errors only after form submission attempt
  const formErrors = isFormSubmitted ? validateErrors : {};

  return (
    <div className={styles.root}>
      {/*     ADDRESS_1     */}
      <TextInput
        {...makeProfileField(ADDRESS_1)}
        value={address1}
        required={address1Required && FIELD_FILLING_TYPES.REQUIRED}
        disabled={isDisabled(ADDRESS_1)}
      />
      <FormErrorBlock type={ADDRESS_1} errors={formErrors} />

      {/*     ADDRESS_2     */}
      <TextInput
        {...makeProfileField(ADDRESS_2)}
        value={address2}
        disabled={isDisabled(ADDRESS_2)}
      />
      <FormErrorBlock type={ADDRESS_2} errors={formErrors} />

      {/*     CITY     */}
      <TextInput
        {...makeProfileField(CITY)}
        required={cityRequired && FIELD_FILLING_TYPES.REQUIRED}
        value={city}
        disabled={isDisabled(CITY)}
      />
      <FormErrorBlock type={CITY} errors={formErrors} />

      {/*     STATE     */}
      <div>
        <SelectCustom
          {...makeProfileField(STATE, FIELD_FILLING_TYPES.REQUIRED)}
          onChange={data => onChange({ state: data })}
          value={state}
          options={statesList}
          needUpdateDefaultValue
          disabled={isDisabled(STATE)}
          required
        />
        <FormErrorBlock type={STATE} errors={formErrors} />
      </div>

      {/*     POSTAL CODE     */}
      <div>
        <TextInput
          {...makeProfileField(
            POSTAL_CODE,
            isAppointmentPatientForm && FIELD_FILLING_TYPES.REQUIRED,
          )}
          limit={zipLimit}
          value={postalCode}
          disabled={isPostalCodeFieldDisabled}
        />
        {isPostalCodeFieldErrorExists && (
          <ErrorBlock
            errors={[
              formatMessage(
                { id: 'errors.validation.profile.postalCode.format' },
                { example: zipExamples },
              ),
            ]}
            className="mt3 w-100"
          />
        )}
      </div>

      {/*     COUNTRY     */}
      <div>
        <SelectCustom
          {...makeProfileField(COUNTRY, FIELD_FILLING_TYPES.REQUIRED)}
          onChange={val => handleCountryChange(val)}
          value={country || targetCountryEntity}
          options={countryList}
          needUpdateDefaultValue
          disabled={isDisabled(COUNTRY)}
          required
        />
        <FormErrorBlock type={COUNTRY} errors={formErrors} />
      </div>

      {/*     HOME_PHONE     */}
      <TextInput
        {...makeProfileField(HOME_PHONE)}
        value={homePhone}
        required={homePhoneRequired && FIELD_FILLING_TYPES.REQUIRED}
        disabled={isPhoneNumberFieldDisabled}
      />

      <FormErrorBlock type={HOME_PHONE} errors={formErrors} />
    </div>
  );
}

HomeAddressRowModeView.propTypes = {
  postalCode: PropTypes.string,
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  country: PropTypes.object,
  homePhone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  statesList: PropTypes.array,
  countryList: PropTypes.array,
  zipLimit: PropTypes.number,
  onCountryChange: PropTypes.func,
  isZipApplicable: PropTypes.bool,
  validateErrors: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  targetCountryEntity: PropTypes.object,
  makeProfileField: PropTypes.func,
  handleCountryChange: PropTypes.func,
  isDisabled: PropTypes.func,
  formatMessage: PropTypes.func,
  zipExamples: PropTypes.string,
  homePhoneRequired: PropTypes.bool,
  cityRequired: PropTypes.bool,
  address1Required: PropTypes.bool,
  isAppointmentPatientForm: PropTypes.bool,
  isFormSubmitted: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/HomeAddress/HomeAddressFormSection/HomeAddressRowModeView.jsx